
import { Options, Vue } from 'vue-class-component';
import Scope1ActivityRecorder from '../components/scope1ActivityRecorder.vue';
import Scope2ActivityRecorder from '../components/scope2ActivityRecorder.vue';
import Scope3ActivityRecorder from '../components/scope3ActivityRecorder.vue';
import TravelLogisticMobilityActivityRecorder from '../components/travelLogisticMobilityActivityRecorder.vue';
import SpendingActivityRecorder from '../components/spendingActivityRecorder.vue';
import * as VM from '@/viewModel';

@Options({
    components: { 
        Scope1ActivityRecorder,
        Scope2ActivityRecorder,
        Scope3ActivityRecorder,
        TravelLogisticMobilityActivityRecorder,
        SpendingActivityRecorder
    },
})
export default class ActivityDataRecorder extends Vue {

    viewModel = VM;
    scopesList: string[] = Object.values(VM.ScopesActivityRecorder);
    selectedScope: string = "";

}
